import { loginToFirebase, getAccessToken, } from "../logic_firebase";

// REST
import { RepositoryFactory } from "../../repository/RepositoryFactory";
const ApiRepository = RepositoryFactory.get("api");

// TODO util
import liff from "@line/liff";
const getLineToken = () => {
  return liff.getIDToken();
};

const getDefaultState = () => ({
  cartCheckResult: null,
  userOrderStatus: null,
  settings: null,
});

// debug
// const sleep = async (msec) => {
//   return new Promise(function (resolve) {
//     setTimeout(resolve, msec);
//   });
// };

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    cartCheckResult (state, val) { state.cartCheckResult = val; },
    userOrderStatus (state, val) { state.userOrderStatus = val; },
    settings (state, val) { state.settings = val; },
  },
  getters: {
    cartCheckResult: (state) => state.cartCheckResult,
    userOrderStatus: (state) => state.userOrderStatus,
    settings: (state) => state.settings,
  },
  actions: {
    //===================================
    // 共通
    //===================================
    /**
     * headers 作成 (LINE, Firebase Auth 両方)
     * @param {*} context 
     * @returns 
     */
    async createAuthHeaders (context) {
      const shopId = context.rootGetters.shopId;
      const lineToken = getLineToken();
      console.log("createAuthHeaders", shopId, lineToken);

      // Firebase Auth トークン (Vuex 内になければ再ログイン -> 再取得)
      let idToken = context.rootGetters.idToken; // Firebase Auth
      if (!idToken) {
        await loginToFirebase(shopId, lineToken);
        idToken = await getAccessToken();
        context.commit("idToken", idToken, { root: true }); // 保存
      }
      return {
        lineToken: lineToken,
        idToken: idToken,
      };
    },
    //===================================
    // REST
    //===================================
    /**
     * 
     * @param {*} context 
     * @returns 
     */
    async getLiffId (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        // await sleep(2000);
        const result = await ApiRepository.getLiffId(shopId);
        const liffId = result.data.liffId;
        console.log(`liffId`, liffId);
        return liffId;
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    /**
     * サービス稼働中かどうか (認証不要)
     * @returns
     */
    async isServiceStatusActive (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const res = await ApiRepository.isServiceStatusActive(shopId);
        console.log(`res=${JSON.stringify(res)}`);
        const active = res.data.data;
        console.log(`active`, active);
        return active;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 受取時間関係設定 取得 (認証不要)
     * @returns 
     */
    async getReceivableSetting (context) {
      try {
        this.commit("rest/settings", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const headers = {};
        const res = await ApiRepository.getReceivableSetting(shopId, headers);
        // console.log(`res=${JSON.stringify(res)}`);
        const settings = res.data.data;
        console.log(`settings`, settings);
        this.commit("rest/settings", settings, { root: true });
        return settings;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 受取日時チェック (認証不要)
     * @param {*} context
     * @param {*} visitTimeYMD
     * @param {*} visitTimeHHMM
     * @returns
     */
    async validateVisitTime (context, { visitTimeYMD, visitTimeHHMM }) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const headers = {};
        const params = {
          visitTimeYMD: visitTimeYMD,
          visitTimeHHMM: visitTimeHHMM,
        };
        const res = await ApiRepository.validateVisitTime(shopId, headers, params);
        // console.log(`res=${JSON.stringify(res)}`);
        return res.data.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * 注文受付状態 取得 (認証不要)
     * @returns
     */
    async getOrderAcceptStatus (context) {
      try {
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }

        const settings = await this.dispatch("rest/getReceivableSetting", { shopId });
        const orderAcceptStatus = settings.orderAcceptStatus;
        return orderAcceptStatus;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * ユーザ注文状態(直近1件) 取得
     * @param {*} context
     * @returns
     */
    async getUserOrderStatusRecent (context) {
      try {
        this.commit("rest/userOrderStatus", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.getUserOrderStatusRecent(shopId, headers);
        // console.log(`res=${JSON.stringify(res)}`);
        // return res.data.data;
        const userOrderStatus = res.data.data;
        console.log(`userOrderStatus`, userOrderStatus);
        this.commit("rest/userOrderStatus", userOrderStatus, { root: true });
        return userOrderStatus;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    /**
     * カート内アイテムチェック
     * @returns 
     */
    async checkItemsInCart (context) {
      try {
        this.commit("rest/cartCheckResult", null, { root: true });
        const shopId = context.rootGetters.shopId;
        if (!shopId) {
          throw new Error("shopId is empty");
        }
        const headers = await this.dispatch("rest/createAuthHeaders");
        const res = await ApiRepository.checkItemsInCart(shopId, headers);
        // console.log(`res=${JSON.stringify(res)}`);
        // return res.data.data;
        const cartCheckResult = res.data.data;
        console.log(`cartCheckResult`, cartCheckResult);
        this.commit("rest/cartCheckResult", cartCheckResult, { root: true });
        return cartCheckResult;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  },
}
